if (document.querySelector("body")?.classList.contains("page-cart")) {
  /*
   * Elements and variables
   */

  let wcsattWrapper = document.querySelector(
    ".wcsatt-wrapper"
  ) as HTMLElement | null;
  let orderTypeChangeButton = document.querySelector(
    ".product-type__change"
  ) as HTMLLinkElement | null;
  let orderTypeSaveButton = document.querySelector(
    ".product-type__change--save"
  ) as HTMLLinkElement | null;
  let oneTimeLabel = document.querySelector(
    ".wcsatt-options-prompt-action-input"
  ) as HTMLLabelElement | null;
  let popupCloseBtn = document.getElementById(
    "popupCloseIcon"
  ) as HTMLElement | null;
  let njamitoCouponButton = document.getElementById(
    "njamito_coupon_button"
  ) as HTMLButtonElement | null;

  //Subscription dropdown options
  let subscriptionOptions = document.querySelectorAll(
    ".wcsatt-options-product-dropdown option"
  );

  if (orderTypeChangeButton && wcsattWrapper) {
    orderTypeChangeButton.addEventListener("click", (e) => {
      if (wcsattWrapper) {
        wcsattWrapper.style.display = "flex";
        oneTimeLabel?.click();
        translateDropdown();
      }
    });
  }

  if (popupCloseBtn) {
    popupCloseBtn.addEventListener("click", (e) => {
      if (wcsattWrapper) {
        wcsattWrapper.style.display = "none";
      }
    });
  }

  if (orderTypeSaveButton) {
    orderTypeSaveButton.addEventListener("click", (e) => {
      orderTypeSaveButton?.classList.add("loading");
      getWcsattOption();
    });
  }

  //Custom Coupon fields functionality
  if (njamitoCouponButton) {
    njamitoCouponButton.addEventListener("click", (e) => {
      let njamitoCouponField = document.getElementById(
        "njamito_coupon_field"
      ) as HTMLInputElement | null;
      let wooCouponField = document.getElementsByName(
        "coupon_code"
      )[0] as HTMLInputElement | null;
      let wooCouponButton = document.getElementsByName(
        "apply_coupon"
      )[0] as HTMLInputElement | null;
    
      if (
        njamitoCouponField &&
        wooCouponField &&
        wooCouponButton
      ) {
        if (!njamitoCouponField.value) return;
        wooCouponField.value = njamitoCouponField.value;
        wooCouponButton.click();
        njamitoCouponField.value = "";
      }
    });
  }

  function getWcsattOption() {
    if (wcsattWrapper) {
      let selectedOption = wcsattWrapper.querySelector(
        'input[name="subscribe-to-action-input"]:checked'
      ) as HTMLInputElement;

      let selectedOptionValue = selectedOption?.value;
      let activeSubscriptionScheme: string = "";

      if (selectedOptionValue == "yes") {
        //Subscription is selected
        let wcsattOptionsDropdown = document.querySelector(
          ".wcsatt-options-product-dropdown"
        ) as HTMLSelectElement;

        if (wcsattOptionsDropdown) {
          activeSubscriptionScheme = wcsattOptionsDropdown.value;
        }
      } else if (selectedOptionValue == "no") {
        //One time is selected
        activeSubscriptionScheme = "";
      }

      setCartState(activeSubscriptionScheme);
    }
  }

  /*
   * Bulk order type AJAX functionality
   */

  function setCartState(activeSubscriptionScheme: string) {
    const ajaxData = (window as any).njamito_ajax;

    if ((window as any).njamito_ajax) {
      let data = new FormData();
      data.append("action", "njamito_set_cart_state_action");
      data.append("activeSubscriptionScheme", activeSubscriptionScheme);
      data.append("nonce", ajaxData.nonce);

      fetch(ajaxData.ajax_url, {
        method: "POST",
        body: data,
      })
        .then((response) => {
          return response.json();
        })
        .then((jsonResponse) => {
          if (!jsonResponse.success) {
          }

          if (jsonResponse.success) {
            location.reload();
          }
        });
    }
  }

  /*
   * Product quantity change
   */

  function initCartQtyBtns() {
    let cartItems = document.querySelectorAll(
      ".woocommerce-cart-form__cart-item"
    ) as NodeListOf<HTMLElement>;

    if (cartItems.length) {
      cartItems.forEach((item) => {
        let itemQty = item.querySelector("#itemQty") as HTMLElement;
        let qtyAdd = item.querySelector("#qtyAdd") as HTMLElement;
        let qtySub = item.querySelector("#qtySub") as HTMLElement;
        let qtyInput = item.querySelector(
          "input[id*='quantity_']"
        ) as HTMLInputElement;

        if (itemQty && itemQty.textContent) {
          if (+itemQty.textContent == +qtyInput.max)
            qtyAdd.setAttribute("disabled", "true");
        }

        if (qtyAdd && qtySub && qtyInput && itemQty) {
          setQtyBtnEvent(qtyAdd, qtyInput, true, itemQty);
          setQtyBtnEvent(qtySub, qtyInput, false, itemQty);
        }
      });
    }

    function setQtyBtnEvent(
      el: HTMLElement,
      qtyInput: HTMLInputElement,
      isAdd: boolean,
      itemQty: HTMLElement
    ) {
      el.addEventListener("click", (e) => {
        e.preventDefault();

        if (isAdd) {
          qtyInput.stepUp(1);
          itemQty.innerText = qtyInput.value;
        } else {
          qtyInput.stepDown(1);
          itemQty.innerText = qtyInput.value;
        }

        updateCart();
      });
    }
  }

  function updateCart() {
    let updateCartBtn = document.getElementsByName("update_cart")[0];

    if (updateCartBtn) {
      updateCartBtn.removeAttribute("disabled");
      updateCartBtn.click();
    }
  }

  let observer = new MutationObserver(observerCallback);

  function setObserver() {
    //Listens for cart form DOM changes
    let cartForm = document.querySelector(
      "form.woocommerce-cart-form"
    ) as HTMLElement;
    if (cartForm) {
      observer.observe(cartForm, { childList: true });
    }
  }

  /*
   * Listens for cart form DOM changes,
   * re-sets the observer to new form Element
   * and re-sets quantity buttons click event listener
   */

  function observerCallback() {
    setObserver();
    initCartQtyBtns();
  }

  /*
   * Translate subscrion type dropdown
   */
  function translateDropdown() {
    if (subscriptionOptions) {
      subscriptionOptions.forEach((el) => {
        if (el) {
          let string = el.innerHTML;
          let translatedString = string.replace("Every day", "Vsak dan");
          translatedString = translatedString.replace(
            "Every week",
            "Vsak teden"
          );
          translatedString = translatedString.replace(
            "Every 2 weeks",
            "Vsak drugi teden"
          );
          el.innerHTML = translatedString;
        }
      });
    }
  }

  //Set form DOM change listener
  setObserver();

  //Set click events on quantity buttons
  initCartQtyBtns();

  //End of file
}
